<template>
  <div class="games-table-header">
    <el-row type="flex" justify="center">
      <el-col :xs="{span: 24}" :sm="{span: 24}" class="game-table">
        <el-row style="margin-top: 1.5em;" type="flex" justify="left">

          <el-col :xs="{span: layout.prefix.xs}" :sm="{span: layout.prefix.sm}" v-if="layout.prefix.show" :class="layout.prefix.extendClass || ''">
            <div style="height: 1px;"></div>
          </el-col>

          <el-col :xs="{span: layout.system.xs}" :sm="{span: layout.system.sm}" v-if="layout.system.show" :class="layout.system.extendClass || ''">
            <div v-if="sortable" class="filter-header clickable" @click="sort('system')">
              System
              <i v-if="sortBy !== 'system'" class="el-icon-d-caret"></i>
              <i v-else-if="order === 1" class="el-icon-caret-bottom"></i>
              <i v-else-if="order === -1" class="el-icon-caret-top"></i>
            </div>
            <div v-else class="filter-header">
              System
            </div>
          </el-col>

          <el-col :xs="{span: layout.spacing.xs}" :sm="{span: layout.spacing.sm}" v-if="layout.spacing.show" :class="layout.spacing.extendClass || ''">
            <div style="height: 1px;"></div>
          </el-col>

          <el-col :xs="{span: layout.name.xs}" :sm="{span: layout.name.sm}" v-if="layout.name.show" :class="layout.name.extendClass || ''">
            <div v-if="sortable" class="filter-header clickable" @click="sort('name')">
              Name
              <i v-if="sortBy !== 'name'" class="el-icon-d-caret"></i>
              <i v-else-if="order === 1" class="el-icon-caret-bottom"></i>
              <i v-else-if="order === -1" class="el-icon-caret-top"></i>
            </div>
            <div v-else class="filter-header">
              Name
            </div>
          </el-col>

          <el-col :xs="{span: layout.spacing.xs}" :sm="{span: layout.spacing.sm}" v-if="layout.spacing.show" :class="layout.spacing.extendClass || ''">
            <div style="height: 1px;"></div>
          </el-col>

          <el-col :xs="{span: layout.status.xs}" :sm="{span: layout.status.sm}" v-if="layout.status.show" :class="layout.status.extendClass || ''">
            <div v-if="sortable" class="filter-header clickable" @click="sort('status')">
              Status
              <i v-if="sortBy !== 'status'" class="el-icon-d-caret"></i>
              <i v-else-if="order === 1" class="el-icon-caret-bottom"></i>
              <i v-else-if="order === -1" class="el-icon-caret-top"></i>
            </div>
            <div v-else class="filter-header">
              Status
            </div>
          </el-col>

          <el-col :xs="{span: layout.postfix.xs}" :sm="{span: layout.postfix.sm}" v-if="layout.postfix.show" :class="layout.postfix.extendClass || ''">
            <div style="height: 1px;"></div>
          </el-col>

        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'GamesTableHeader',
  components: {
  },
  props: {
    sort: {
      default: () => {}
    },
    sortable: {
      default: false
    },
    sortBy: {
      default: 'name'
    },
    order: {
      default: 1
    },
    options: {
      type: Object,
      default: function () {
        return {
          prefix: {
            show: false,
            xs: 5,
            sm: 4,
            md: 4,
            extendClass: ''
          },
          spacing: {
            show: false,
            xs: 11,
            sm: 10,
            md: 10,
            extendClass: ''
          },
          postfix: {
            show: false,
            xs: 4,
            sm: 3,
            md: 3,
            extendClass: ''
          },
          system: {
            show: false,
            xs: 5,
            sm: 4,
            md: 4,
            extendClass: ''
          },
          name: {
            show: false,
            xs: 11,
            sm: 10,
            md: 10,
            extendClass: ''
          },
          status: {
            show: false,
            xs: 4,
            sm: 3,
            md: 3,
            extendClass: ''
          }
        }
      }
    }
  },
  computed: {
    layout () {
      return {
        prefix: Object.assign({ show: false, xs: 5, sm: 4, md: 4, extendClass: '' }, this.options.prefix || {}),
        spacing: Object.assign({ show: false, xs: 11, sm: 10, md: 10, extendClass: '' }, this.options.spacing || {}),
        postfix: Object.assign({ show: false, xs: 4, sm: 3, md: 3, extendClass: '' }, this.options.postfix || {}),
        system: Object.assign({ show: false, xs: 5, sm: 4, md: 4, extendClass: '' }, this.options.system || {}),
        name: Object.assign({ show: false, xs: 11, sm: 10, md: 10, extendClass: '' }, this.options.name || {}),
        status: Object.assign({ show: false, xs: 4, sm: 3, md: 3, extendClass: '' }, this.options.status || {})
      }
    }
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>
<style lang="scss">
@import '../styles/variables.scss';

.games-table-header {
  margin-bottom: 20px;

  .filter-header {
    font-size: $font-size-regular;
  }

  @media screen and (max-width: 35em) {
    .filter-header {
      font-size: $font-size-small;
    }
  }
}
</style>
